export function stopPropagation(e: React.UIEvent): void {
    e.stopPropagation()
}
